<template lang='pug'>
  router-link.favorite-card.component(:to='{ name: "merchant", params: {id: business.id} }')
    bf-flex.stamp.component.centered( v-if='business.sample' ) 
      label {{$t("SAMPLE")}}
    
    .unfavor(@click.stop.prevent='unfavor')
      fav-icon
    .vip(v-if='vip=="VIP"')
      img(src='/ui/vip.svg')
    img(
      :src='business.logo || "/no-image.png" '
      :class='{ empty: !business.logo }'
    )
    .info
      h5.title {{ business.name }}
      .phone( v-if='business.phone' ) {{ business.phone }}
      .web( v-if='business.web' ) {{ business.web }}
    .coupon( v-if='coupons.length' )
      h6 {{coupons[0].title}}
</template>

<script>
  import { db } from '@/main'

  export default {
    name: 'favorite-card.component',

    props: [ 'favorite', 'account' ],

    data() {
      return {
        business: {},
        
      }
    },

    computed: {
      vip(){
        return this.cust && this.cust.length ? this.cust[0].category : ''
      }
    },

    firestore() {
      return {
        business: db.collection('businesses').doc( this.favorite.business_id ),
        cust: db.collection( 'customers' ).where( 'business_id', '==', this.favorite.business_id ).where( 'account_id', '==', this.account.id),
        coupons: db.collection('coupons').where('biz.id', '==', this.favorite.business_id)
      }
    },

    methods: {
      unfavor() {
        if ( confirm( this.$t("Are you sure you want to remove")  + ` "${this.business.name}" ` + this.$t("from your favorites list?")  ) )
          db.collection('favorites').doc( this.favorite.id ).delete()
      }
    }
  }
</script>

<style scoped lang='stylus'>
  .favorite-card
    position relative
    display block
    min-height 235px
    height 100%
    
    .unfavor
      position absolute
      right 5px
      top 5px
      font-size 1.65em
      color red
    .vip
      position absolute 
      left -30px
      top -30px
      transform rotate(-36deg)
      
    .coupon
      position absolute
      width 94.5%
      padding 5px
      background yellow
      bottom 2px
      text-align center
      
    img
      width 100%
      height 96px
      object-fit contain
      &.empty
        object-fit contain
        padding 28px
        box-sizing border-box
        background rgba( 240 240 240 .8 )
      
    .info
      padding 12px 16px 16px 16px
      .web
        overflow hidden
        text-overflow ellipsis
        max-width 120px
      > *
        margin-bottom 4px
    .title
      margin-bottom 8px
      color var(--clr-blue)
  
  .stamp
    color blue
    font-size 4em
    position absolute
    height 100%
    width 100%
    label
      display block
      transform rotate(-36deg)
      font-weight bolder
      font-family 'arial black'
      letter-spacing 2px
      color rgba( 40 200 200 .2)
</style>
